export enum AddressType {
  Correspondance = "Correspondance",
}
